import React from 'react';
import { colors, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { FilePdf, FileXlsx } from '@insurancemenu/imenu-components-lib/dist/icons';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { observer } from 'mobx-react-lite';
import { usePostSubmitDownloadProposalPageStore } from 'store/pages/post-submit/post-submit-download-proposal/pageStore';
import {
  DOWNLOAD_CONFIRMED_PROPOSAL_SPINNER_TEST_ID,
  DOWNLOAD_PDF_TILE_TEST_ID,
  DOWNLOAD_XLSX_TILE_TEST_ID,
} from '../constants';
import { ActionListStyled, ActionTileStyled, TitleStyled, WrapperStyled } from './styles';

const DownloadConfirmedProposalFiles: React.FC = observer(() => {
  const { isLoading, pdfFilePath, xlsxFilePath } = usePostSubmitDownloadProposalPageStore();

  function onDownloadPdf(): void {
    if (pdfFilePath) {
      downloadByUrl(pdfFilePath);
    }
  }

  function onDownloadXlsx(): void {
    if (xlsxFilePath) {
      downloadByUrl(xlsxFilePath);
    }
  }

  return (
    <WrapperStyled>
      {isLoading ? (
        <OverlaySpinner display data-test-id={DOWNLOAD_CONFIRMED_PROPOSAL_SPINNER_TEST_ID} />
      ) : (
        <>
          <TitleStyled>Proposal Documents</TitleStyled>
          <ActionListStyled>
            {pdfFilePath !== null && (
              <ActionTileStyled
                icon={<FilePdf width="5.4rem" color={colors.red[600]} />}
                actionName="Download File"
                action={onDownloadPdf}
                message="Export the proposal in PDF format for easy viewing and printing"
                dataTestId={DOWNLOAD_PDF_TILE_TEST_ID}
              />
            )}
            {xlsxFilePath !== null && (
              <ActionTileStyled
                icon={<FileXlsx width="5.4rem" color={colors.green[600]} />}
                actionName="Download File"
                action={onDownloadXlsx}
                message="Export the proposal data in Excel format for detailed analysis"
                dataTestId={DOWNLOAD_XLSX_TILE_TEST_ID}
              />
            )}
          </ActionListStyled>
        </>
      )}
    </WrapperStyled>
  );
});

export default DownloadConfirmedProposalFiles;
